import ActionTypes from '../actions/types';
import { defaultState } from './defaultState';
import { setState } from './helper';

const initialState = defaultState.navOptions;

export default (state = initialState, action) => {
  switch(action.type) {
    case ActionTypes.SET_DRAWER_STATE:
      return setState(state, action, 'isDrawerOpened');

    case ActionTypes.SET_NAV_HELP_STATE:
      return setState(state, action, 'isNavHelpOpened');

    case ActionTypes.SET_NAV_SEARCH_STATE:
      return setState(state, action, 'isSearchFormOpened');

    case ActionTypes.SET_NAV_SEARCH_PEOPLE_STATE:
      return setState(state, action, 'isFindPeopleFormOpened');

    case ActionTypes.SET_NAV_CHECKOUT_STATE:
      return setState(state, action, 'isCheckoutPageOpened');

    case ActionTypes.SET_NAV_SPOT_INFO_DETAILED_VIEW:
      return setState(state, action, 'spotInfoDetailedView');

    case ActionTypes.RESET_NAV_OPTIONS:
      return initialState;

    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/reducers/navOptionsReducer.js